import {ListItemProps} from '@genestack/ui';
import React from 'react';

import {ListItemLink} from '../../../../components/list-item-link';

export interface Props extends ListItemProps {
    queryId: number;
}

export const QueryLink = (props: Props) => {
    const {queryId, ...listItemProps} = props;

    return <ListItemLink to={`/${queryId}`} data-qa-id="query" {...listItemProps} />;
};
